import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Romaneio de Entrega")
], -1)
const _hoisted_3 = { class: "card-header pb-0" }
const _hoisted_4 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_5 = { class: "table-responsive p-0" }
const _hoisted_6 = { class: "table align-items-center mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Pedido"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Loja"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, [
      /*#__PURE__*/_createTextVNode("Capacidade "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Estimada/Alocada")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Embalagens"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, " Janela Entrega "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, " Veículo ")
  ])
], -1)
const _hoisted_8 = { class: "d-flex px-2 py-1" }
const _hoisted_9 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_10 = { class: "mb-0 text-sm" }
const _hoisted_11 = { class: "text-xs text-secondary mb-0" }
const _hoisted_12 = { class: "text-center text-uppercase text-secondary text-xxs" }
const _hoisted_13 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_14 = { class: "text-center text-uppercase text-secondary text-xxs" }
const _hoisted_15 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_16 = { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_17 = { class: "tags-container-romaneio" }
const _hoisted_18 = { class: "text-uppercase text-secondary text-xxs" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pedidos, (rota) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", null, "#" + _toDisplayString(rota.id) + " " + _toDisplayString(rota.name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Pedidos, (pedido) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(pedido.numero_pedido), 1),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(pedido.brand), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(pedido.id_operacao), 1)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(pedido.capacidade) + "/" + _toDisplayString(pedido.embalagens.length), 1)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedido.embalagens, (tag, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "tag-romaneio"
                          }, _toDisplayString(tag.codigo_embalagem), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString($setup.fDate(pedido.janela_entrega_inicio)), 1),
                      _hoisted_19,
                      _createElementVNode("span", null, _toDisplayString($setup.fDate(pedido.janela_entrega_fim)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      (pedido.rota)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(pedido.rota.veiculo.modelo), 1))
                        : _createCommentVNode("", true),
                      _hoisted_22,
                      (pedido.rota)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(pedido.rota.veiculo.marca), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 256))
              ])
            ])
          ])
        ])
      ]))
    }), 256))
  ]))
}